import React from 'react';
import Avatar from './Avatar';

type ProfileImageProps = {
  src?: string | null;
  name?: string | null;
  lastName?: string | null;
  sizeRem?: number;
  className?: string;
};

export const ProfileImage: React.FC<ProfileImageProps> = ({
  src,
  name,
  lastName,
  sizeRem = 7.5,
  className,
}) => {
  const resolveDriveUrl = (original?: string | null): string | undefined => {
    if (!original) return undefined;
    try {
      // Formats supported:
      // - https://drive.google.com/file/d/<FILE_ID>/view?usp=sharing
      // - https://drive.google.com/open?id=<FILE_ID>
      // - https://drive.google.com/uc?id=<FILE_ID>&export=download
      const d1 = original.match(/drive\.google\.com\/file\/d\/([^/]+)/i);
      const d2 = original.match(/[?&]id=([^&]+)/i);
      const fileId = (d1 && d1[1]) || (d2 && d2[1]);
      if (fileId) {
        return `https://drive.google.com/uc?export=view&id=${fileId}`;
      }
      return original;
    } catch {
      return original || undefined;
    }
  };
  const finalSrc = resolveDriveUrl(src);
  const alt = [name, lastName].filter(Boolean).join(' ').trim() || 'Foto de perfil';
  if (finalSrc && finalSrc.trim().length > 0) {
    const sizePx = `${sizeRem}rem`;
    return (
      <img
        src={finalSrc}
        alt={alt}
        className={className}
        style={{
          width: sizePx,
          height: sizePx,
          borderRadius: '50%',
          border: '5px solid white',
          marginTop: '-2rem',
          boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15), 0 4px 10px rgba(0, 0, 0, 0.1)',
          objectFit: 'cover',
          background: '#E6E3EE',
        }}
      />
    );
  }
  return <Avatar name={name || ''} lastName={lastName || ''} sizeRem={sizeRem} className={className} />;
};

export default ProfileImage;


